import * as Sentry from '@sentry/react';
import { hasAuthGroup, hasFlowAccess, isLocalDevelopmentAuth } from './auth';
import { FLOW, getAdminGroupName } from './constants';
import { getCookie } from './cookies';
import { useStore } from './store';
import { showToast } from './toast';

async function main(): Promise<void> {
  await useStore.getState().fetchAuthUser();
  useStore.getState().captureEpisodeIdFromUrl();

  const { authUser } = useStore.getState();
  if (authUser?.user) {
    Sentry.setUser({ username: authUser.user });
  }

  if (!hasFlowAccess(authUser)) {
    useStore.setState({ mode: 'accessDenied' });
    return;
  }

  const isGroupAdmin =
    isLocalDevelopmentAuth(authUser) || hasAuthGroup(authUser, getAdminGroupName());

  let op = getCookie('operator');

  if (FLOW === 'seccapreason') {
    op = authUser?.user || op || (isLocalDevelopmentAuth(authUser) ? 'local-dev' : '');
    useStore.getState().setOperator(op);
    return;
  }

  if (authUser?.user) {
    if (isGroupAdmin) {
      if (!op) op = authUser.user;
    } else {
      op = authUser.user;
    }
  }

  if (op) {
    useStore.getState().setOperator(op);
    const { episodeSpecifyFromUrl, isAdmin } = useStore.getState();
    if (episodeSpecifyFromUrl) {
      if (!isAdmin && !authUser?.user) {
        await useStore.getState().registerOperator(op);
      }
      await useStore.getState().launchEpisodeSpecifyFromState();
      void useStore.getState().updateDashboardMetrics();
      return;
    }
    if (isAdmin) {
      await useStore.getState().showDashboard();
    } else {
      if (!authUser?.user) {
        await useStore.getState().registerOperator(op);
      }
      await useStore.getState().showDashboard();
    }
  } else {
    useStore.getState().setOperator('');
    const { episodeSpecifyFromUrl } = useStore.getState();
    if (episodeSpecifyFromUrl) {
      await useStore.getState().launchEpisodeSpecifyFromState();
    } else {
      await useStore.getState().showUserSelection();
    }
    void useStore.getState().updateDashboardMetrics();
  }
}

export function initApp(): Promise<void> {
  return main().catch((err) => {
    console.error(err);
    showToast('Failed to initialize');
  });
}
